<div class="{{theme}}-theme audio-parent" *ngIf="conclusion">
    <div class="position-relative border-bottom" *ngIf="conclusion">
        <div class="topic-wrapper">
            <div class="conclusion border-lg-right">
                <div class="container-fluid pb-4">
                    <div class="row py-4">
                        <div class="col-12 py-3">
                            <h1 [innerHtml]="conclusion.title"></h1>
                        </div>
                    </div>
                    <audio-transcript [source]="conclusion.audioUrl" [transcript]="conclusion.transcript">
                    </audio-transcript>
                    <div class="d-none d-lg-block" *ngIf="textSection">
                        <div class="row">
                            <div class="offset-2 col-10 py-4" [innerHTML]="textSection.text"></div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="{{conclusion.featureImageUrl}}" class="topic-featured-img" />
            <div class="conclusion d-lg-none" *ngIf="textSection">
                <div class="container-fluid py-4">
                    <div class="row">
                        <div class="offset-2 col-10 text-large" [innerHTML]="textSection.text" ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dark-theme  audio-parent" *ngIf="secondSection">
    <div class="position-relative">
        <div class="topic-wrapper">
            <div class="conclusion">
                <div class="container-fluid py-3">
                    <div class="row pb-5">
                        <div class="col-12 py-4">
                            <h1 [innerHtml]="secondSection.title"></h1>
                        </div>
                    </div>
                    <audio-transcript [source]="audioconclusion" [transcript]="secondSection.transcript">
                    </audio-transcript>
                    <div class="row d-none d-lg-flex">
                        <div class="offset-2 col-10 text-xlarge" *ngIf="resultText" [innerHtml]="resultText"></div>
                    </div>
                </div>
            </div>
            <div class="conclusion flower-graph-container py-5 border-top border-bottom border-y-lg-0">
                <flower [answers]="answers" [mode]="'conclusion'"></flower>
            </div>
            <div class="container-fluid pt-4 pb-5 d-lg-none">
                <div class="row">
                    <div class="offset-2 col-10 text-xlarge" *ngIf="resultText" [innerHtml]="resultText"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="reflection-journal-theme border-bottom" *ngIf="caseStudySection">
    <div class="container-fluid border-bottom">
        <div class="row py-4">
            <div class="col-12">
                <h3 class="font-italic case-study">Case Study</h3>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row py-4">
            <div class="col-12 col-lg-6 py-3 order-2 order-lg-1">
                <h2 [innerHtml]="caseStudySection.title"></h2>
                <b>
                    <div class="subtitle py-4" [innerHtml]="caseStudySection.subtitle"></div>
                </b>
                <div [innerHtml]="caseStudySection.text"></div>
            </div>
            <div class="col-12 col-lg-6 py-3 order-1 order-lg-2">
                <img class="img-fluid w-100" src="{{caseStudySection.imageUrl}}" />
            </div>
        </div>
    </div>
</div>